function closeCookiePopup() {
    const cookieCloseBtn = document.querySelector('.js-cookie-close');

    cookieCloseBtn.addEventListener('click', () => {
        cookiePopup.classList.remove('show');
    })
}

// Helper for retrieving cookies
function getCookie (name) {
	let value = `; ${document.cookie}`;
	let parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}

// Get hideBanner cookie
const hideBanner = getCookie('hidecookiebanner');

// If it's not set, show cookie banner and set hideBanner cookie for 30 days
if(!hideBanner) {
    cookiePopup.classList.add('show');
    document.cookie = `hidecookiebanner='true'; path=/; max-age=${60 * 60 * 24 * 30};`;
}
